<template>
  <v-col cols="12">
    <v-hover>
      <template v-slot:default="{ hover }">
        <v-card
          :color="hover ? '#C8DBE4' : 'secondaryBackground'"
          rounded="lg"
          :height="rowHeight"
          v-if="story"
        >
          <v-container class="pa-0" fill-height>
            <v-row class="fill-height" no-gutters>
              <v-col cols="auto" class="ma-0 pa-0">
                <v-img
                  v-if="getCoverArt(story)"
                  class="rounded-lg"
                  @load="loaded = $event"
                  :height="rowHeight"
                  :max-width="imageWidth"
                  :min-width="imageWidth"
                  :src="getCoverArt(story)"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <v-sheet
                  v-else
                  class="rounded-lg white--text font-weight-bold pa-5 text-h6"
                  :height="rowHeight"
                  :width="imageWidth"
                  color="#636262"
                  elevation="0"
                >
                  <v-row height align="center" class="fill-height" no-gutters>
                    <v-col style="line-height: 1em">{{
                      $t("storyHub.noCoverImage")
                    }}</v-col>
                  </v-row>
                </v-sheet>
              </v-col>
              <v-col class="pa-0">
                <v-row class="ma-0 fill-height">
                  <v-col cols="5" class="pa-3 text-left">
                    <h2 v-if="story.name && story.name != ''">
                      {{ story.name }}
                    </h2>
                    <h2 v-else class="secondaryAction--text">
                      {{ $t("storyHub.untitledStory") }}
                    </h2>
                    <StoryListInfo
                      v-if="story.status"
                      :status="story.status._id"
                      :statusUpdatedAt="story.statusUpdatedAt"
                      :summary="story.summary"
                      :_id="story._id"
                      :name="story.name"
                      :hideBottom="hover"
                      :startChapter="story.startChapter"
                      location="[location goes here]"
                    />
                    <v-slide-y-transition>
                      <v-btn
                        v-if="hover"
                        color="primary"
                        :to="'/storyhub/' + story._id + '/basic-info/'"
                        style="position: absolute; bottom: 0.5rem"
                        ><v-icon left>mdi-cog</v-icon
                        >{{ $t("story.editStory") }}</v-btn
                      >
                    </v-slide-y-transition>
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <v-card
                      color="transparent"
                      elevation="0"
                      class="text-left"
                      width="100%"
                    >
                      <div style="width: 100%">
                        <StoryHubChipGroup
                          :totalReviewCount="story.reviews.totalCount"
                          :duration="story.duration"
                          :genre="story.genre"
                          :ageRating="story.ageRating"
                          :reviews="story.reviews"
                        />
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="auto" style="height: 100%;"
                    ><div
                      class="accentElement rounded-lg"
                      style="width: 3px; height: 93%"
                    ></div
                  ></v-col>
                  <v-col cols="4" class="pa-0">
                    <v-row
                      v-if="story.status._id == STORY_STATUS.InReview"
                      class="fill-height status"
                      align="center"
                    >
                      <StoryListItemStatus
                        :status="$t('storyHub.publishing.pendingReview')"
                        :updated="
                          $t('storyHub.publishing.submitted') +
                          ': ' +
                          formatDate(story.statusUpdatedAt)
                        "
                      />
                    </v-row>
                    <v-row
                      v-else-if="story.status._id == STORY_STATUS.Published"
                      class="fill-height status"
                      align="center"
                    >
                      <StoryListItemStatus
                        :status="$t('storyHub.publishing.published')"
                        :updated="formatDate(story.statusUpdatedAt)"
                      />
                    </v-row>
                    <v-row
                      v-else
                      class="fill-height status"
                      align="center"
                      no-gutters
                    >
                      <StoryListItemStatus
                        :status="$t('storyHub.publishing.inDraft')"
                        :updated="
                          $t('storyHub.publishing.created') +
                          ': ' +
                          formatDate(story.statusUpdatedAt)
                        "
                      />
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </template>
    </v-hover>
  </v-col>
</template>
<script>
import StoryHubChipGroup from "./StoryListChipGroup";
import StoryListInfo from "./StoryListInfo";
import StoryListItemStatus from "./StoryListItemStatus.vue";
import moment from "moment";
import { STORY_STATUS } from "@/const";
export default {
  props: {
    story: Object,
  },
  components: {
    StoryHubChipGroup,
    StoryListInfo,
    StoryListItemStatus,
  },
  data() {
    return {
      rowHeight: "11.2rem",
      imageWidth: "7rem",
      loaded: false,
    };
  },
  methods: {
    formatDate(dateString) {
      return moment(dateString).format("MMMM D, YYYY");
    },
    getCoverArt(story) {
      if (story.coverArt && story.coverArt.contentUrl) {
        return story.coverArt.contentUrl;
      }
      return null;
    },
    getAverageRating(reviews) {
      let ratingCount = 0;
      let ratingTotal = 0;
      for (const review of reviews.edges) {
        ratingTotal = review.rating + ratingTotal;
        ratingCount++;
      }
      let average = ratingTotal / ratingCount;

      return average;
    },
  },
  computed: {
    STORY_STATUS() {
      return STORY_STATUS;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep a {
  text-decoration: none;
}
</style>